import { renderState } from "../../../core/js/state-machine";
import { alertNotice } from "../../../core/js/helpers/built-in-icons";
import {
    componentName,
    componentClasses,
    applyMask,
    maskInitChars,
} from "../../../core/components/input-mask/input-mask";
import validateInitialization from "../../../core/js/helpers/validate-initialization";

const views = {
    valid: {
        attrs: { "aria-invalid": "false" },
        classList: [`!${componentClasses.validated}`],
    },
    invalid: {
        attrs: { "aria-invalid": "true" },
        classList: [`${componentClasses.validated}`],
    },
};

const validateHTML = (element) => {
    const maskInput = element.querySelector(`.${componentClasses.input}`);
    return maskInput ? { maskInput } : false;
};

const InputMask = (element, props = {}) => {
    const [success, mergedProps, validElements] = validateInitialization({
        componentName,
        element,
        props,
        views,
        validateHTML,
    });
    if (!success) return;

    if (mergedProps.mask) {
        mergedProps.mask = String(mergedProps.mask).trim();
    }

    const bindMask = (event) => {
        const mask = mergedProps.mask.split("");
        const maskChars = mergedProps.mask.split("").filter((i) => {
            return i !== maskInitChars.numberChar;
        });
        const oldStart = event.target.selectionStart;
        if (event.data && !event.data.match(/[0-9]/g) && event.data !== " " && event.data !== "-") {
            validElements.maskInput.value = validElements.maskInput.value.replace(event.data, "");
            validElements.maskInput.value = applyMask(
                mask,
                maskInitChars.numberChar,
                validElements.maskInput
            );
            event.target.selectionStart = oldStart;
            event.target.selectionEnd = oldStart;
        } else {
            const checkCurrentSpot = (nextChar) => {
                // Check if current is mask char
                if (
                    maskChars.includes(validElements.maskInput.value[nextChar - 1]) &&
                    !maskChars.includes(validElements.maskInput.value[nextChar])
                ) {
                    if (maskChars.includes(validElements.maskInput.value[oldStart - 1])) {
                        validElements.maskInput.selectionStart = nextChar + 1;
                        validElements.maskInput.selectionEnd = nextChar + 1;
                    } else {
                        validElements.maskInput.selectionStart = nextChar;
                        validElements.maskInput.selectionEnd = nextChar;
                    }
                } else {
                    //Check if next char is mask char. If not take the next char place. If yes, find next available.
                    if (maskChars.includes(validElements.maskInput.value[nextChar])) {
                        checkCurrentSpot(nextChar + 1);
                    } else {
                        validElements.maskInput.selectionStart = nextChar;
                        validElements.maskInput.selectionEnd = nextChar;
                    }
                }
            };
            if (event.inputType === "deleteContentBackward") {
                const isPreviousNumber = (char) => {
                    if (maskChars.includes(validElements.maskInput.value[char - 1])) {
                        isPreviousNumber(char - 1);
                    } else {
                        validElements.maskInput.selectionStart = char;
                        validElements.maskInput.selectionEnd = char;
                    }
                };
                validElements.maskInput.value = applyMask(
                    mask,
                    maskInitChars.numberChar,
                    validElements.maskInput
                );
                isPreviousNumber(oldStart);
            } else {
                validElements.maskInput.value = applyMask(
                    mask,
                    maskInitChars.numberChar,
                    validElements.maskInput
                );
                checkCurrentSpot(oldStart);
            }
        }
    };

    const validate = () => {
        const enteredValue = validElements.maskInput.value.replace(
            /[0-9]/g,
            maskInitChars.numberChar
        );
        if (enteredValue === mergedProps.mask) {
            validElements.maskInput.setCustomValidity("");
            renderState(views.valid, element);
        } else {
            validElements.maskInput.setCustomValidity("invalid");
            if (!element.querySelector("svg")) {
                renderState(views.invalid, element);
                validElements.maskInput.insertAdjacentHTML(
                    "afterend",
                    alertNotice({ class: componentClasses.errorIcon })
                );
            } else {
                renderState(views.invalid, element);
            }
        }
    };

    // Handle show/hide button click
    const dispose = () => {
        validElements.maskInput.removeEventListener("input", bindMask);
        element[componentName] = null;
        element = null;
    };

    // Add event listeners
    if (mergedProps.mask) {
        validElements.maskInput.addEventListener("input", bindMask);
    }

    const api = {
        element,
        dispose,
        validate,
    };

    element[componentName] = api;
    // Return ourselves incase we are captured in js.
    return api;
};

export default InputMask;
